/** A failed response as an Error carrying the API's own message, or the fallback when it has none. */
export async function fail(res: Response, fallback: string): Promise<never> {
  const body = (await res.json().catch(() => null)) as { error?: { message?: string } } | null
  throw new Error(body?.error?.message ?? fallback)
}
